module.exports = __webpack_public_path__ + "static/img/til104.3920a25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/til104.png
// module id = iPf7
// module chunks = 1